import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { RelationShipTypeViewModel } from '../../../models/Entities/Person/RelationshipType/RelationshipTypeModels';

// store
import * as RelationshipTypesStore from '../../../redux/middleware/PersonRelationshipTypes.Middleware';

export interface IProps {}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  relationshipTypes: RelationShipTypeViewModel[];
}

interface DispatchProps {
  GetRelationshipTypes: typeof RelationshipTypesStore.actionCreators.GetRelationshipTypes;
  DeleteRelationshipType: typeof RelationshipTypesStore.actionCreators.DeleteRelationshipType;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonRelationshipTypes?.isLoadingAll,
  isLoadingSuccessfully: state.PersonRelationshipTypes?.successLoadingAll,
  failOnLoading: state.PersonRelationshipTypes?.failOnLoadingAll,
  isDeleting: state.PersonRelationshipTypes?.isDeletingOne,
  failOnDeleting: state.PersonRelationshipTypes?.failOnDeletingOne,
  error: state.PersonRelationshipTypes?.error,
  relationshipTypes: (state.PersonRelationshipTypes?.list ?? [])
    .filter((item: RelationShipTypeViewModel) => !item.isDeleted)
    .slice()
    .sort((a: RelationShipTypeViewModel, b: RelationShipTypeViewModel) =>
      (a.name || '').localeCompare(b.name || '')
    ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...RelationshipTypesStore.actionCreators
};
